import { z } from 'zod';
import { schemaUserResourceSetItem } from '../user_resource_set';

export type EventTypeResourceSetListItem = z.infer<
  typeof schemaEventTypeResourceSetListItem
>;
export const schemaEventTypeResourceSetListItem = z.object({
  userResourceSet: schemaUserResourceSetItem,
  priority: z.number(),
  sort: z.number(),
});
